import React from "react";
import StudentAuth from "./StudentAuth/StudentAuth";
import TeacherAuth from "./TeacherAuth/TeacherAuth";
import SelectUserType from "./SelectUserType/SelectUserType";
import { Route, Switch } from "react-router-dom";
import PasswordChange from "./PasswordChange/PasswordChange";
import ForgottenPassword from "./ForgottenPassword/FogottenPassword";
import LogoutConfirmation from "./LogoutConfirmation/LogoutConfirmation";
import AppSelect from "../../components/AppSelect/AppSelect";
import AuthenticationCustomErrors from "./AuthenticationCustomErrors/AuthenticationCustomErrors";
import { BASE_ROUTE, ROUTES } from "./routes";
import RedirectionQueryLogin from "./RedirectionQueryLogin/RedirectionQueryLogin";

import "./Authentication.scss";

const Authentication = () => {
    return (
        <div className="user-authentication-container">
            <Switch>
                <Route path={`/${BASE_ROUTE}/${ROUTES.customError}`}>
                    <AuthenticationCustomErrors />
                </Route>

                <Route>
                    <div className="user-auth__content">
                        <AppSelect className="user-auth__app-select" />
                        <Switch>
                            <Route
                                path={`/${BASE_ROUTE}/${ROUTES.studentAuth}`}
                            >
                                <StudentAuth />
                            </Route>
                            <Route
                                path={`/${BASE_ROUTE}/${ROUTES.teacherPwdChange}`}
                            >
                                <PasswordChange />
                            </Route>
                            <Route
                                path={`/${BASE_ROUTE}/${ROUTES.teacherForgottenPwd}`}
                            >
                                <ForgottenPassword />
                            </Route>
                            <Route
                                path={`/${BASE_ROUTE}/${ROUTES.teacherAuth}`}
                            >
                                <TeacherAuth />
                            </Route>
                            <Route
                                path={`/${BASE_ROUTE}/${ROUTES.logoutConfirmation}`}
                            >
                                <LogoutConfirmation />
                            </Route>
                            <Route
                                path={`/${BASE_ROUTE}/${ROUTES.redirectionQueryLogin}`}
                            >
                                <RedirectionQueryLogin />
                            </Route>

                            <Route>
                                <SelectUserType />
                            </Route>
                        </Switch>
                    </div>
                </Route>
            </Switch>
        </div>
    );
};
export default Authentication;
